import { AlertCircle, RefreshCw, ShieldAlert, Wifi } from 'lucide-react';

const ErrorMessage = ({
  title = 'Oops! Something went wrong',
  message = 'We encountered an unexpected error while processing your request. Please try again in a moment.',
  onRetry,
  type = 'api'
}: {
  title?: string;
  message?: string;
  onRetry?: () => void;
  type?: 'api' | 'network' | 'permission' | 'server';
}) => {
  const getIcon = () => {
    switch (type) {
      case 'network':
        return <Wifi className='h-12 w-12 text-red-500' />;
      case 'permission':
        return <ShieldAlert className='h-12 w-12 text-red-500' />;
      case 'api':
      case 'server':
      default:
        return <AlertCircle className='h-12 w-12 text-red-500' />;
    }
  };

  return (
    <div className='mx-auto mb-4 w-[70%] rounded-xl border border-red-100 bg-white p-8 shadow-sm'>
      <div className='flex flex-col items-center justify-center space-y-6'>
        <div className='relative'>
          <div className='flex h-20 w-20 items-center justify-center rounded-full bg-red-50'>
            {getIcon()}
          </div>
          <div className='absolute -inset-1 animate-ping rounded-full bg-red-100 opacity-20'></div>
        </div>
        <div className='space-y-2 text-center'>
          <h3 className='text-xl font-semibold text-gray-900'>{title}</h3>
          <p className='max-w-md text-gray-600'>{message}</p>
        </div>
        {onRetry && (
          <button
            onClick={onRetry}
            className='inline-flex items-center space-x-2 rounded-lg bg-red-500 px-4 py-2 font-medium text-white transition-colors duration-200 hover:bg-red-600'
          >
            <RefreshCw className='h-4 w-4' />
            <span>Try Again</span>
          </button>
        )}
      </div>
    </div>
  );
};

export default ErrorMessage;
